import { render } from "./PropertyProfile.vue?vue&type=template&id=bd840162"
import script from "./PropertyProfile.vue?vue&type=script&lang=js"
export * from "./PropertyProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__